import React, { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { FiCheckCircle, FiXCircle, FiShield } from "react-icons/fi"

import { verifyCertificate } from "../services/operations/assessmentAPI"
import CertificateCard from "../components/core/Certificate/CertificateCard"

export default function CertificateVerify() {
  const { credentialId } = useParams()
  const [loading, setLoading] = useState(true)
  const [cert,    setCert]    = useState(null)
  const [error,   setError]   = useState("")

  useEffect(() => {
    ;(async () => {
      const res = await verifyCertificate(credentialId)
      if (res?.success) {
        setCert(res.data)
      } else {
        setError(res?.message || "Certificate not found")
      }
      setLoading(false)
    })()
  }, [credentialId])

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-yellow-50 border-t-transparent" />
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      {/* Header */}
      <div className="mb-8 flex items-center gap-3">
        <FiShield size={28} className="text-caribbeangreen-300" />
        <div>
          <h1 className="text-xl font-bold text-richblack-5">Certificate Verification</h1>
          <p className="text-xs text-richblack-400">KodeVedic · Credential ID: {credentialId}</p>
        </div>
      </div>

      {error ? (
        <div className="rounded-2xl border border-pink-400/30 bg-pink-400/5 p-8 text-center">
          <FiXCircle size={40} className="mx-auto mb-3 text-pink-400" />
          <p className="font-semibold text-richblack-5">Invalid Certificate</p>
          <p className="mt-1 text-sm text-richblack-400">{error}</p>
        </div>
      ) : (
        <>
          {/* Verified banner */}
          <div className="mb-6 flex items-center gap-3 rounded-2xl border border-caribbeangreen-300/30 bg-caribbeangreen-300/5 px-5 py-4">
            <FiCheckCircle size={22} className="shrink-0 text-caribbeangreen-300" />
            <div>
              <p className="font-semibold text-caribbeangreen-300">Verified Credential</p>
              <p className="text-xs text-richblack-300">
                This certificate was issued by KodeVedic and is authentic.
              </p>
            </div>
          </div>

          <CertificateCard
            certificate={cert}
            studentName={`${cert?.student?.firstName ?? ""} ${cert?.student?.lastName ?? ""}`.trim()}
          />
        </>
      )}

      <div className="mt-8 text-center">
        <Link to="/" className="text-sm text-richblack-400 hover:text-richblack-100">
          ← Back to KodeVedic
        </Link>
      </div>
    </div>
  )
}
